// extracted by mini-css-extract-plugin
export default {"moreDetail":"wWb_3","moreDetailText":"cTjR1","moreDetailIcon":"YVE8Z"};